'use client';

import { c as _c } from "react/compiler-runtime";
import { TextPassage } from '@petsmart-ui/sparky';
import { getENV, useDecisions } from '@libs/common-next';
import type { StoreItemProps } from '@/components/StoreDirectory';
import { servicesToDisplay } from '@/utils/store-details-services-module';
import { StoreDetailsServiceLink } from './store-details-service-link';
import './store-details-services-module.scss';
export function StoreDetailsServicesModule(t0) {
  const $ = _c(11);
  const {
    store
  } = t0;
  const isIsscEnabled = useDecisions("issc");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getENV("NEXT_PUBLIC_LOCALE");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isUSMarket = t1 === "en-US";
  let t2;
  if ($[1] !== isIsscEnabled || $[2] !== store.ActiveStorePrograms) {
    t2 = isIsscEnabled && isUSMarket && store.ActiveStorePrograms.includes("ISSC");
    $[1] = isIsscEnabled;
    $[2] = store.ActiveStorePrograms;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const shouldHideVetHours = t2;
  let t3;
  if ($[4] !== store.TimeZone?.TimeZoneId) {
    const timezonedDate = new Date().toLocaleString("en", {
      timeZone: store.TimeZone?.TimeZoneId
    });
    t3 = new Date(timezonedDate);
    $[4] = store.TimeZone?.TimeZoneId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const currentDate = t3;
  let t4;
  if ($[6] !== currentDate || $[7] !== shouldHideVetHours || $[8] !== store) {
    const sortedServices = store.StoreServices.filter(_temp).sort(_temp2);
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <TextPassage className="store-details-services__headline" size="lg">{"Services hours & details"}</TextPassage>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = <div className="store-details-services">{t5}{sortedServices.map(service => <StoreDetailsServiceLink key={service.ServiceName} currentDate={currentDate} service={service} shouldHideVetHours={shouldHideVetHours} store={store} />)}</div>;
    $[6] = currentDate;
    $[7] = shouldHideVetHours;
    $[8] = store;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp2(a, b) {
  if (a.ServiceName === "Adoptions") {
    return 1;
  }
  if (b.ServiceName === "Adoptions") {
    return -1;
  }
  return 0;
}
function _temp(t0) {
  const {
    ServiceName
  } = t0;
  return servicesToDisplay.includes(ServiceName);
}